import React from 'react'

const SvgRoundRight = props => (
    <svg width="1em" height="1em" viewBox="0 0 14 14" {...props}>
        <path d="M1.734 5.455a5.284 5.284 0 013.761-1.558h5.892L9.394 1.904A.704.704 0 0110.39.91l3.23 3.231a.704.704 0 010 .995L10.48 8.273a.7.7 0 01-.497.205.704.704 0 01-.497-1.2l1.975-1.974H5.495A3.888 3.888 0 002.73 6.45a3.887 3.887 0 00-1.147 2.767v3.375a.703.703 0 11-1.406 0V9.217a5.277 5.277 0 011.558-3.762z" />
    </svg>
)

export default SvgRoundRight
